module.exports = __webpack_public_path__ + "media/images/main/main-future2-c06bc75ad8328d93ae51d74069b8204d.jpg";